module.exports = __webpack_public_path__ + "img/documentReport.e08ff3d3.svg";